import { debounce } from '@nodeModules/throttle-debounce';
import emailSpellChecker from '@nodeModules/@zootools/email-spell-checker';

export const emailSpellCheckerPlugin = () => {
	const extendedTopLevelDomains = ['hr', 'ba', 'si', ...emailSpellChecker.POPULAR_TLDS];
	const $inputEmails = document.querySelectorAll('.js-input-email');

	const validateEmail = (email) => {
	  	return Boolean(String(email)
	    	.toLowerCase()
	    	.match(
	      	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	    ));
	};

	const getSuggestion = function(element) {
		const $el = element;

		if (validateEmail($el.value)) {
			const suggestion = emailSpellChecker.run({
  				email: $el.value,
  				domains: [...emailSpellChecker.POPULAR_DOMAINS],
  				secondLevelDomains: ['yahoo', 'hotmail', 'mail', 'live', 'outlook'],
  				topLevelDomains: [...extendedTopLevelDomains]
			})

			if (suggestion && suggestion?.full !== $el.value) {
				if ($el.nextElementSibling) {
					$el.nextElementSibling.firstElementChild.innerText = suggestion.full;
				} else {
					const suggestionEl = document.createElement('div');
					suggestionEl.classList.add('input__suggestion');
					suggestionEl.innerHTML = `
						${window.bootData.emailSpellCheckerSuggestionMsg} <span role="button" class="input__suggestion-action">${suggestion.full}</span>?
						<button type="button" class="input__suggestion-remove js-suggestion-remove">&#x2717;</button>
					`;

					$el.parentElement.appendChild(suggestionEl);
					$el.nextElementSibling.lastElementChild.addEventListener('click', event => {
						event.target.parentNode.remove()
					})

					$el.nextElementSibling.firstElementChild.addEventListener('click', event => {
						$el.value = event.target.innerText;
						$el.dispatchEvent(new Event('input'));
						$el.dispatchEvent(new Event('blur'));

						event.target.parentNode.remove()
					})
				}
			} else if ($el.nextElementSibling) {
				$el.nextElementSibling.remove()
			}
		}
	}

	const debouncedGetSuggestion = debounce(300, getSuggestion);

	['keydown', 'paste', 'input'].forEach(function(e) {
		$inputEmails.forEach((input) => {
	  		input.addEventListener(e, event => {
				debouncedGetSuggestion(event.target);
	  		});
		})
	});
}
